import react from 'React';
import {Tooltip as ReactTooltip} from 'react-tooltip';

const ContentItemPublishedStatus = ({ item }: { item: any }) => {
    function getItemStatus(item) {
        if(item.status === "draft") {
            if(item.requiresModeration){
                return "Moderation"
            }
            return 'Draft'
        } else if (item.status === 'published') {
            return 'Published'
        } else if (item.status === 'publishedWithDraftChanges') {
            return 'Published with changes drafted'
        }
    };

    return (
        <div className="content-status-container" data-tooltip-id={`tooltip-status-code-${item.id}`} data-tooltip-content={getItemStatus(item)}>
            <span className={`content-status-icon ${getItemStatus(item)?.split(' ').join('-')}`} />
            
            <span className="sr-only">{getItemStatus(item)}</span>

            <ReactTooltip id={`tooltip-status-code-${item.id}`} place="top" className="thrive-tooltip no-width" aria-hidden="true" />
        </div>
    );
};

export default ContentItemPublishedStatus;